<template>
  <div class="care-sleep-section">
    <div class="care-sleep-section__main container">
      <div class="care-sleep-section__video">
        <video
          :src="'/media/video/care/section-4-ui.mp4'"
          muted
          playsinline
          autoplay
          loop
        />
      </div>
      <div class="care-sleep-section__content">
        <div class="care-sleep-section__title">
          <img
            src="/media/img/icons/care/icon_sleep_tracking.svg"
            alt="icon"
          >
          {{$t('care.sliderSleep.title')}}
        </div>
        <p class="care-sleep-section__description">
          {{$t('care.sectionSleep.desc')}}
        </p>
        <a
          class="care-sleep-section__link"
          href="https://support.lollipop.camera/hc/en-us/articles/900000772266-How-to-make-sleep-tracking-work-properly-"
          target="_blank"
        >
          {{$t('care.sectionSleep.linkText')}}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CareSleepSection',
};
</script>

<style lang="sass" scoped>
.container
  width: 100%;
  padding: 0 9vw;

  @media screen and (max-width: 1440px)
    padding: 0 3vw;

  @media screen and (max-width: 414px)
    padding: 0 30px;

  @media screen and (max-width: 375px)
    padding: 0 25px;

.care-sleep-section
  width: 100%
  height: 100%
  pointer-events: none
  opacity: 0
  transition: opacity 0.5s ease-in-out

  .page-care__scroll.active-3 &,
    transition: opacity 0.5s 0.5s ease-in-out
    pointer-events: auto
    opacity: 1

  &__main
    width: 100%
    height: 100%
    display: flex
    justify-content: center
    flex-direction: column

    @media screen and (orientation: portrait), (max-width: 768px)
      justify-content: flex-end

  &__video
    width: 750px
    position: absolute
    top: 50%;
    left: 50%
    transform: translate(-50%, -50%) translate(32.5%, 120%)
    display: flex
    align-items: flex-start

    @media screen and (max-width: 1440px)
      max-width: 560px
      transform: translate(-50%, -50%) translate(32.5%, 110%)

    @media screen and (max-width: 1024px)
      max-width: 485px

    @media screen and (orientation: portrait), (max-width: 768px)
      max-width: 370px
      width: 100%
      position: static
      left: auto
      transform: none
      margin: 270px auto 40px

    @media screen and (max-width: 414px)
      margin: 240px auto 40px

    @media screen and (max-width: 375px)
      margin: 220px auto 30px

    video
      width: 100%
      border-radius: 20px
      overflow: hidden

  &__content
    max-width: 500px
    text-align: left
    z-index: 2

    @media screen and (max-width: 1440px)
      max-width: 360px

    @media screen and (max-width: 1024px)
      max-width: 300px

    @media screen and (orientation: portrait), (max-width: 768px)
      flex: 1 1 auto
      max-width: none
      width: 100%
      text-align: center
      transform: translate(0, 5%);
      transition: transform 0.5s ease-in-out

      .page-care__scroll.active-3 &
        transform: none;
        transition: transform 0.5s 0.5s ease-in-out

      .page-care__scroll.active-4 &
        transform: translate(0, -5%);
        transition: transform 0.5s ease-in-out

  &__title
    font-size: 40px
    display: flex
    align-items: center
    margin-bottom: 48px

    @media screen and (max-width: 1440px)
      font-size: 32px
      margin-bottom: 32px

    @media screen and (max-width: 1024px)
      font-size: 24px
      margin-bottom: 26px

    @media screen and (orientation: portrait), (max-width: 768px)
      font-size: 20px
      justify-content: center
      margin-bottom: 12px

    @media screen and (orientation: portrait), (max-width: 375px)
      margin-bottom: 8px

    img
      margin-right: 20px

      @media screen and (orientation: portrait), (max-width: 375px)
        width: 40px
        margin-right: 12px

  &__description
    font-size: 24px
    margin-bottom: 48px

    @media screen and (max-width: 1440px)
      font-size: 18px
      margin-bottom: 32px

    @media screen and (max-width: 1024px)
      font-size: 16px

    @media screen and (orientation: portrait), (max-width: 375px)
      margin-bottom: 25px

  &__link
    text-decoration: underline
    font-size: 20px

    @media screen and (max-width: 1440px)
      font-size: 14px
</style>
